var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pin LOGO-PIN",class:{ pointer: _vm.isCMS},style:({
    top: `${_vm.logo.value.y}%`,
    left: `${_vm.logo.value.x}%`,
    width: `${_vm.logo.value.logo_width}%`,
    transform: `skewY(${_vm.logo.value.logo_skew}deg)`,
  }),on:{"mouseenter":_vm.over,"mouseleave":_vm.out,"click":_vm.click}},[_c('img',{attrs:{"alt":_vm.logo.value.logo_alt ? _vm.logo.value.logo_alt : '',"src":_vm.getMedia(_vm.logo.value.logo_image.path)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }